import React from "react";
import Dashboard from "../Dashboard"
import MenuPage from "../pages/settings/Menu";
import UserPage from "../pages/settings/User";
import MenuPermission from "../pages/settings/MenuPermission"
import RolePage  from "../pages/settings/Role";
import TobaccoProductTypePage  from "../pages/masters/Tobacco_product_type";
import TobaccoProductPage  from "../pages/masters/Tobacco_product";
import DependenceLevelPage  from "../pages/masters/Dependence_level";
import QuestionPage  from "../pages/masters/Question";
import TobaccoUsersListPage from "../pages/tobacco_user/list";
import UserDetails from "../pages/tobacco_user/detail";
const protectedRoutes = [
  { path: "dashboard", element : <Dashboard />},
  { path: "settings/menu", element: <MenuPage /> },
  { path: "settings/user", element: <UserPage /> },
  { path: "settings/menu_permission", element: <MenuPermission /> },
  { path: "settings/role", element: <RolePage /> },
  { path: "masters/tobacco_product_type", element: <TobaccoProductTypePage /> },
  { path: "masters/tobacco_product", element: <TobaccoProductPage /> },
  { path: "masters/dependence_level", element: <DependenceLevelPage /> },
  { path: "question", element: <QuestionPage /> },
  { path: "tobacco_users", element: <TobaccoUsersListPage /> },
  { path: "/user_detail", element: <UserDetails />}
]

export default protectedRoutes;